import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/app/product/[id]/product-client.tsx");
